import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// One Bootstrap instance for #documentShowModal.
// Do not remove the modal from the DOM on close — that breaks later opens
// and leaves orphaned backdrops that steal clicks from the close button.
export default class extends Controller {
  connect() {
    this.ensureModal()
  }

  open(event) {
    this.ensureModal()?.show()
  }

  close(event) {
    this.ensureModal()?.hide()
  }

  ensureModal() {
    const element = document.getElementById("documentShowModal")
    if (!element) return null

    this.modal = Modal.getOrCreateInstance(element)
    return this.modal
  }
}
